(function () {
  const yearlyPowers = [
    'Plano (0.00)', '-0.25', '-0.50', '-0.75', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25',
    '-2.50', '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75',
    '-5.00', '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00', '-8.50',
    '-9.00', '-9.50', '-10.00', '-10.50', '-11.00', '-11.50', '-12.00', '-12.50', '-13.00', '-13.50',
    '-14.00', '-14.50', '-15.00', '+0.25', '+0.50', '+0.75', '+1.00', '+1.25', '+1.50', '+1.75',
    '+2.00', '+2.25', '+2.50', '+2.75', '+3.00', '+3.25', '+3.50', '+3.75', '+4.00', '+4.25',
    '+4.50', '+4.75', '+5.00', '+5.25', '+5.50', '+5.75', '+6.00', '+6.50', '+7.00', '+7.50',
    '+8.00', '+8.50', '+9.00', '+9.50', '+10.00', '+10.50', '+11.00', '+11.50', '+12.00', '+12.50',
    '+13.00', '+13.50', '+14.00', '+14.50', '+15.00'
  ];
  const monthlyPowers = ['Plano (0.00)', '-1.00', '-1.50', '-2.00', '-2.50', '-3.00', '-3.50', '-4.00', '-4.50', '-5.00'];
  const naturalVisionPowers = [
    'Plano (0.00)', '-0.50', '-0.75', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50',
    '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00',
    '-5.25', '-5.50', '-5.75', '-6.00'
  ];
  const magicTopPowers = [
    'Plano (0.00)', '-0.50', '-0.75', '-1.00', '-1.25', '-1.50', '-1.75', '-2.00', '-2.25', '-2.50',
    '-2.75', '-3.00', '-3.25', '-3.50', '-3.75', '-4.00', '-4.25', '-4.50', '-4.75', '-5.00',
    '-5.25', '-5.50', '-5.75', '-6.00', '-6.50', '-7.00', '-7.50', '-8.00', '+0.25', '+0.50',
    '+0.75', '+1.00', '+1.25', '+1.50', '+1.75', '+2.00', '+2.25', '+2.50', '+2.75', '+3.00'
  ];

  const productLines = [
    {
      id: 'hidrocor-monthly', brand: 'Solótica', name: 'Hidrocor Monthly',
      colors: ['Amber', 'Crystal', 'Ocre', 'Quartz', 'Cielo', 'Topaz'], powers: monthlyPowers,
      prices: [{ max: 49, price: 30 }, { max: 99, price: 29 }, { max: 499, price: 26 }, { max: null, price: 24 }]
    },
    {
      id: 'hidrocor-yearly', brand: 'Solótica', name: 'Hidrocor Yearly',
      colors: ['Agate', 'Amber', 'Aquamarine', 'Buzios', 'Cielo', 'Copacabana', 'Crystal', 'Graphite', 'Hazel', 'Ipanema', 'Jade', 'Honey', 'Ocre', 'Parati', 'Quartz', 'Sapphire', 'Topaz'], powers: yearlyPowers,
      prices: [{ max: 49, price: 43 }, { max: 99, price: 42 }, { max: 499, price: 40 }, { max: null, price: 38 }]
    },
    {
      id: 'natural-colors-yearly', brand: 'Solótica', name: 'Natural Colors Yearly',
      colors: ['Agate', 'Amber', 'Hazel', 'Buzios', 'Cielo', 'Crystal', 'Graphite', 'Ice', 'Ipanema', 'Jade', 'Honey', 'Ocre', 'Quartz', 'Sapphire', 'Topaz'], powers: yearlyPowers,
      prices: [{ max: 49, price: 43 }, { max: 99, price: 42 }, { max: 499, price: 40 }, { max: null, price: 38 }]
    },
    {
      id: 'solflex-natural-colors', brand: 'Solótica', name: 'Solflex Natural Colors',
      colors: ['Crystal', 'Emerald', 'Honey', 'Ocre', 'Quartz', 'Topaz', 'Green'], powers: monthlyPowers,
      prices: [{ max: 49, price: 30 }, { max: 99, price: 29 }, { max: 499, price: 26 }, { max: null, price: 24 }]
    },
    {
      id: 'color-hype', brand: 'Solótica', name: 'Color Hype',
      colors: ['White', 'Yellow', 'Red'], powers: ['Plano (0.00)'],
      prices: [{ max: 49, price: 35 }, { max: 99, price: 34 }, { max: 499, price: 32 }, { max: null, price: 32 }]
    },
    {
      id: 'beauty-monthly', brand: 'Natural Vision', name: 'Beauty Monthly',
      colors: ['Diamond', 'Tourmaline', 'Lapis Lazuli'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 20 }, { max: 99, price: 19 }, { max: 499, price: 17 }, { max: null, price: 17 }]
    },
    {
      id: 'beauty-yearly', brand: 'Natural Vision', name: 'Beauty Yearly',
      colors: ['Agate', 'Diamond', 'Tourmaline', 'Lapis Lazuli'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 39 }, { max: 99, price: 38 }, { max: 499, price: 36 }, { max: null, price: 36 }]
    },
    {
      id: 'glamour-monthly', brand: 'Natural Vision', name: 'Glamour Monthly',
      colors: ['Amber', 'Crystal', 'Emerald', 'Ice', 'Quartz', 'Topaz'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 20 }, { max: 99, price: 19 }, { max: 499, price: 17 }, { max: null, price: 17 }]
    },
    {
      id: 'glamour-yearly', brand: 'Natural Vision', name: 'Glamour Yearly',
      colors: ['Amber', 'Crystal', 'Emerald', 'Ice', 'Quartz', 'Topaz'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 39 }, { max: 99, price: 38 }, { max: 499, price: 36 }, { max: null, price: 36 }]
    },
    {
      id: 'dreams-monthly', brand: 'Natural Vision', name: 'Dreams Monthly',
      colors: ['Bronze', 'Green', 'Graphite', 'Turquoise'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 20 }, { max: 99, price: 19 }, { max: 499, price: 17 }, { max: null, price: 17 }]
    },
    {
      id: 'dreams-yearly', brand: 'Natural Vision', name: 'Dreams Yearly',
      colors: ['Bronze', 'Green', 'Graphite', 'Turquoise'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 39 }, { max: 99, price: 38 }, { max: 499, price: 36 }, { max: null, price: 36 }]
    },
    {
      id: 'ellegant-monthly', brand: 'Natural Vision', name: 'Ellegant Monthly',
      colors: ['Blue', 'Gray', 'Green', 'Honey'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 20 }, { max: 99, price: 19 }, { max: 499, price: 17 }, { max: null, price: 17 }]
    },
    {
      id: 'ellegant-yearly', brand: 'Natural Vision', name: 'Ellegant Yearly',
      colors: ['Blue', 'Gray', 'Green', 'Honey'], powers: naturalVisionPowers,
      prices: [{ max: 49, price: 39 }, { max: 99, price: 38 }, { max: 499, price: 36 }, { max: null, price: 36 }]
    },
    {
      id: 'fantasy', brand: 'Natural Vision', name: 'Fantasy',
      colors: ['White', 'Yellow', 'Black', 'Red'], powers: ['Plano (0.00)'],
      prices: [{ max: 49, price: 30 }, { max: 99, price: 29 }, { max: 499, price: 27 }, { max: null, price: 27 }]
    },
    {
      id: 'magic-top-yearly', brand: 'Optolentes', name: 'Magic Top Yearly',
      colors: ['Blue', 'Gray', 'Green', 'Honey', 'Lavender', 'Ocre', 'Turquoise'], powers: magicTopPowers,
      prices: [{ max: 49, price: 66 }, { max: 99, price: 65 }, { max: 499, price: 63 }, { max: null, price: 63 }]
    }
  ];

  const labelsByLang = {
    en: {
      empty: 'No quantities added yet.', pairs: 'pairs', pairPrice: 'Pair Price', lineTotal: 'Line Total', totalPairs: 'Total Pairs', shipping: 'Shipping', grandTotal: 'Grand Total', companyInfo: 'Company Information', company: 'Company', contact: 'Contact', contactNumber: 'Contact Number', country: 'Country', orderTotals: 'Order Totals', productSubtotal: 'Product Subtotal', color: 'Color', power: 'Power', qtyPairs: 'Qty Pairs', requestSent: 'Request Sent', submitRequest: 'Submit Request', sending: 'Sending...', submittedTitle: 'Request Submitted', notConfiguredTitle: 'Submission Not Configured', errorTitle: 'Submission Error', errorMessage: 'Could not submit the request. Please try again.', close: 'Close', minWarning: 'Minimum 10 pairs required for this product line. You can combine colors and powers within this same product line.', navigationBlocked: 'Before selecting another product line, add enough quantities to reach 10 pairs in this line or clear the quantities entered.', endpointMissing: 'Automatic submission is not configured. Add the submission endpoint in the theme editor.', successMessage: 'Your wholesale request has been submitted successfully. Our team will contact you shortly.'
    },
    es: {
      empty: 'Aún no se agregaron cantidades.', pairs: 'pares', pairPrice: 'Precio por par', lineTotal: 'Total de línea', totalPairs: 'Total de pares', shipping: 'Envío', grandTotal: 'Total general', companyInfo: 'Información de la empresa', company: 'Empresa', contact: 'Contacto', contactNumber: 'Número de contacto', country: 'País', orderTotals: 'Totales del pedido', productSubtotal: 'Subtotal de productos', color: 'Color', power: 'Graduación', qtyPairs: 'Cant. pares', requestSent: 'Solicitud enviada', submitRequest: 'Enviar solicitud', sending: 'Enviando...', submittedTitle: 'Solicitud enviada', notConfiguredTitle: 'Envío no configurado', errorTitle: 'Error de envío', errorMessage: 'No se pudo enviar la solicitud. Inténtalo nuevamente.', close: 'Cerrar', minWarning: 'Se requiere un mínimo de 10 pares para esta línea de producto. Puedes combinar colores y graduaciones dentro de la misma línea.', navigationBlocked: 'Antes de seleccionar otra línea, agrega cantidades suficientes para llegar a 10 pares en esta línea o borra las cantidades ingresadas.', endpointMissing: 'El envío automático no está configurado. Agrega el endpoint en el editor del tema.', successMessage: 'Tu solicitud mayorista fue enviada correctamente. Nuestro equipo te contactará pronto.'
    },
    fr: {
      empty: 'Aucune quantité ajoutée pour le moment.', pairs: 'paires', pairPrice: 'Prix par paire', lineTotal: 'Total de ligne', totalPairs: 'Total de paires', shipping: 'Expédition', grandTotal: 'Total général', companyInfo: 'Informations entreprise', company: 'Entreprise', contact: 'Contact', contactNumber: 'Numéro de contact', country: 'Pays', orderTotals: 'Totaux de commande', productSubtotal: 'Sous-total produits', color: 'Couleur', power: 'Correction', qtyPairs: 'Qté paires', requestSent: 'Demande envoyée', submitRequest: 'Envoyer la demande', sending: 'Envoi...', submittedTitle: 'Demande envoyée', notConfiguredTitle: 'Envoi non configuré', errorTitle: 'Erreur d’envoi', errorMessage: 'Impossible d’envoyer la demande. Veuillez réessayer.', close: 'Fermer', minWarning: 'Un minimum de 10 paires est requis pour cette ligne de produits. Vous pouvez combiner couleurs et corrections dans la même ligne.', navigationBlocked: 'Avant de sélectionner une autre ligne, ajoutez suffisamment de quantités pour atteindre 10 paires dans cette ligne ou effacez les quantités saisies.', endpointMissing: 'L’envoi automatique n’est pas configuré. Ajoutez l’endpoint dans l’éditeur du thème.', successMessage: 'Votre demande en gros a bien été envoyée. Notre équipe vous contactera bientôt.'
    }
  };
  let labels = labelsByLang.en;

  function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>'"]/g, (character) => ({
      '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
    })[character]);
  }

  function initialize(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const lang = (root.dataset.locale || document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    labels = labelsByLang[lang] || labelsByLang.en;

    const companyForm = root.querySelector('[data-b2b-company-form]');
    const brandList = root.querySelector('[data-b2b-brand-list]');
    const lineList = root.querySelector('[data-b2b-line-list]');
    const gridWrap = root.querySelector('[data-b2b-grid-wrap]');
    const liveSummary = root.querySelector('[data-b2b-live-summary]');
    const finalSummary = root.querySelector('[data-b2b-final-summary]');
    const modal = root.querySelector('[data-b2b-modal]');
    const modalTitle = root.querySelector('[data-b2b-modal-title]');
    const modalMessage = root.querySelector('[data-b2b-modal-message]');
    const modalDetails = root.querySelector('[data-b2b-modal-details]');
    const modalButton = modal.querySelector('.pl-b2b-modal__btn');
    const endpoint = root.dataset.submissionEndpoint || '';
    const state = {
      activeBrand: productLines[0].brand,
      activeLineId: productLines[0].id,
      quantities: {}
    };
    let submittedOrderHash = null;

    const getLine = (id) => productLines.find((line) => line.id === id);
    const brands = () => [...new Set(productLines.map((line) => line.brand))];
    const linesByBrand = (brand) => productLines.filter((line) => line.brand === brand);
    const money = (value) => `$ ${Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

    function getQty(lineId, color, power) {
      return Number(state.quantities[lineId]?.[color]?.[power] || 0);
    }

    function setQty(lineId, color, power, quantity) {
      state.quantities[lineId] ||= {};
      state.quantities[lineId][color] ||= {};
      state.quantities[lineId][color][power] = Math.max(0, parseInt(quantity || 0, 10) || 0);
      submittedOrderHash = null;
    }

    function lineTotalQty(lineId) {
      const line = getLine(lineId);
      return line.colors.reduce((total, color) => total + line.powers.reduce((powerTotal, power) => powerTotal + getQty(lineId, color, power), 0), 0);
    }

    function pairPrice(line, quantity) {
      if (quantity < 10) return 0;
      return line.prices.find((tier) => tier.max === null || quantity <= tier.max)?.price || 0;
    }

    function allLinesSummary() {
      return productLines.map((line) => {
        const quantity = lineTotalQty(line.id);
        const price = pairPrice(line, quantity);
        return { line, quantity, price, total: quantity >= 10 ? quantity * price : 0 };
      });
    }

    const totalPairs = () => allLinesSummary().reduce((sum, row) => sum + row.quantity, 0);
    const productSubtotal = () => allLinesSummary().reduce((sum, row) => sum + row.total, 0);
    const shippingValue = () => {
      const quantity = totalPairs();
      if (quantity < 10 || quantity >= 100) return 0;
      return quantity <= 49 ? 35 : 30;
    };
    const shippingLabel = () => {
      const quantity = totalPairs();
      if (quantity < 10) return '$ -';
      return quantity >= 100 ? 'Free Shipping' : money(shippingValue());
    };
    const invalidProductLines = () => allLinesSummary().filter((row) => row.quantity > 0 && row.quantity < 10);

    function showModal(options = {}) {
      modalTitle.textContent = options.title || 'Notice';
      modalMessage.textContent = options.message || '';
      if (options.details?.length) {
        modalDetails.hidden = false;
        modalDetails.innerHTML = options.details.map((item) => `<div><span>${escapeHtml(item.label)}</span><strong>${escapeHtml(item.value)}</strong></div>`).join('');
      } else {
        modalDetails.hidden = true;
        modalDetails.innerHTML = '';
      }
      modalButton.textContent = options.button || 'Continue Editing';
      modal.hidden = false;
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('pl-b2b-modal-open');
      modalButton.focus();
    }

    function closeModal() {
      modal.hidden = true;
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('pl-b2b-modal-open');
    }

    function showMinimumModal(line, quantity) {
      showModal({
        title: 'Minimum Order Requirement',
        message: labels.navigationBlocked,
        details: [
          { label: 'Current Product Line', value: line.name },
          { label: 'Current Quantity', value: `${quantity} pairs` },
          { label: 'Minimum Required', value: '10 pairs' }
        ]
      });
    }

    function canLeaveActiveLine() {
      const quantity = lineTotalQty(state.activeLineId);
      if (quantity === 0 || quantity >= 10) return true;
      showMinimumModal(getLine(state.activeLineId), quantity);
      return false;
    }

    function validateOrder() {
      const invalid = invalidProductLines();
      if (invalid.length) {
        showMinimumModal(invalid[0].line, invalid[0].quantity);
        return false;
      }
      if (totalPairs() < 10) {
        showModal({ title: 'Minimum Order Requirement', message: 'Add at least 10 pairs to continue.' });
        return false;
      }
      return true;
    }

    function setStep(step) {
      root.querySelectorAll('[data-b2b-step]').forEach((panel) => {
        panel.hidden = panel.dataset.b2bStep !== step;
      });
      const stepIndex = step === 'company' ? 0 : step === 'builder' ? 1 : 2;
      root.querySelectorAll('.pl-b2b-step').forEach((item, index) => {
        item.classList.toggle('is-active', index === stepIndex);
        item.classList.toggle('is-complete', index < stepIndex);
      });
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function renderBrandList() {
      brandList.innerHTML = brands().map((brand) => {
        const quantity = linesByBrand(brand).reduce((sum, line) => sum + lineTotalQty(line.id), 0);
        return `<button type="button" class="pl-b2b-brand-btn${brand === state.activeBrand ? ' is-active' : ''}" data-brand="${escapeHtml(brand)}"><strong>${escapeHtml(brand)}</strong><span>${quantity ? `${quantity} pairs` : 'View lines'}</span></button>`;
      }).join('');
    }

    function renderLineList() {
      root.querySelector('[data-b2b-active-brand-title]').textContent = state.activeBrand;
      lineList.innerHTML = linesByBrand(state.activeBrand).map((line) => {
        const quantity = lineTotalQty(line.id);
        return `<button type="button" class="pl-b2b-line-btn${line.id === state.activeLineId ? ' is-active' : ''}" data-line-id="${line.id}"><strong>${escapeHtml(line.name)}</strong><span>${quantity ? `${quantity} pairs` : 'No quantities'}</span></button>`;
      }).join('');
    }

    function renderGrid() {
      const line = getLine(state.activeLineId);
      root.querySelector('[data-b2b-active-brand]').textContent = line.brand;
      root.querySelector('[data-b2b-active-line]').textContent = line.name;
      let html = `<table class="pl-b2b-quantity-grid"><thead><tr><th>Diopters (Power)</th>${line.colors.map((color) => `<th>${escapeHtml(color)}</th>`).join('')}</tr></thead><tbody>`;
      line.powers.forEach((power) => {
        html += `<tr><th>${escapeHtml(power)}</th>${line.colors.map((color) => {
          const quantity = getQty(line.id, color, power);
          return `<td><input type="number" min="0" step="1" inputmode="numeric" value="${quantity || ''}" aria-label="${escapeHtml(`${line.name}, ${color}, ${power}`)}" data-grid-input data-line-id="${line.id}" data-color="${escapeHtml(color)}" data-power="${escapeHtml(power)}"></td>`;
        }).join('')}</tr>`;
      });
      gridWrap.innerHTML = `${html}</tbody></table>`;
    }

    function renderLiveSummary() {
      const summaries = allLinesSummary().filter((row) => row.quantity > 0);
      liveSummary.innerHTML = summaries.length
        ? `<div class="pl-b2b-summary-lines">${summaries.map((row) => {
          const invalid = row.quantity < 10;
          return `<div class="pl-b2b-summary-line${invalid ? ' is-invalid' : ''}"><strong>${escapeHtml(row.line.name)}</strong><span>${row.quantity} ${labels.pairs}</span><small>${labels.pairPrice}: ${row.price ? money(row.price) : '$ -'}</small><small>${labels.lineTotal}: ${money(row.total)}</small>${invalid ? `<em>${labels.minWarning}</em>` : ''}</div>`;
        }).join('')}</div>`
        : `<p class="pl-b2b-empty">${labels.empty}</p>`;
      liveSummary.insertAdjacentHTML('beforeend', `<div class="pl-b2b-summary-total"><span>${labels.totalPairs}</span><strong>${totalPairs()}</strong></div><div class="pl-b2b-summary-total"><span>${labels.shipping}</span><strong>${shippingLabel()}</strong></div><div class="pl-b2b-summary-total"><span>${labels.grandTotal}</span><strong>${money(productSubtotal() + shippingValue())}</strong></div>`);
      root.querySelector('[data-b2b-review-order]').disabled = invalidProductLines().length > 0 || totalPairs() < 10;
    }

    function filledItemsForLine(line) {
      const items = [];
      line.colors.forEach((color) => line.powers.forEach((power) => {
        const quantity = getQty(line.id, color, power);
        if (quantity > 0) items.push({ color, power, quantity });
      }));
      return items;
    }

    function companyData() {
      return Object.fromEntries(new FormData(companyForm).entries());
    }

    function orderHash() {
      return JSON.stringify({ company: companyData(), quantities: state.quantities });
    }

    function renderFinalSummary() {
      const company = companyData();
      const rows = allLinesSummary().filter((row) => row.quantity > 0);
      let html = `<div class="pl-b2b-final-grid"><div class="pl-b2b-final-card"><h3>${labels.companyInfo}</h3><p><strong>${labels.company}:</strong> ${escapeHtml(company.company_name)}</p><p><strong>${labels.contact}:</strong> ${escapeHtml(company.contact_name)}</p><p><strong>Email:</strong> ${escapeHtml(company.email)}</p><p><strong>${labels.contactNumber}:</strong> ${escapeHtml(company.contact_number)}</p><p><strong>${labels.country}:</strong> ${escapeHtml(company.country)}</p></div><div class="pl-b2b-final-card"><h3>${labels.orderTotals}</h3><p><strong>${labels.totalPairs}:</strong> ${totalPairs()}</p><p><strong>${labels.shipping}:</strong> ${shippingLabel()}</p><p><strong>${labels.productSubtotal}:</strong> ${money(productSubtotal())}</p><p><strong>${labels.grandTotal}:</strong> ${money(productSubtotal() + shippingValue())}</p></div></div><div class="pl-b2b-final-products">`;
      rows.forEach((row) => {
        html += `<article class="pl-b2b-final-product"><div class="pl-b2b-final-product__head"><div><span>${escapeHtml(row.line.brand)}</span><h3>${escapeHtml(row.line.name)}</h3></div><div><strong>${row.quantity} ${labels.pairs}</strong><small>${labels.pairPrice}: ${money(row.price)}</small></div></div><table><thead><tr><th>${labels.color}</th><th>${labels.power}</th><th>${labels.qtyPairs}</th></tr></thead><tbody>${filledItemsForLine(row.line).map((item) => `<tr><td>${escapeHtml(item.color)}</td><td>${escapeHtml(item.power)}</td><td>${item.quantity}</td></tr>`).join('')}</tbody></table></article>`;
      });
      const alreadySubmitted = submittedOrderHash === orderHash();
      html += `</div><button class="pl-b2b-btn pl-b2b-btn--primary" type="button" data-b2b-submit${alreadySubmitted ? ' disabled' : ''}>${alreadySubmitted ? labels.requestSent : labels.submitRequest}</button>${alreadySubmitted ? `<p class="pl-b2b-success-note">${labels.successMessage}</p>` : ''}`;
      finalSummary.innerHTML = html;
    }

    function buildEmailBody() {
      const company = companyData();
      const body = [
        `Company: ${company.company_name || ''}`,
        `Contact: ${company.contact_name || ''}`,
        `Email: ${company.email || ''}`,
        `Contact Number: ${company.contact_number || ''}`,
        `Country: ${company.country || ''}`,
        '',
        'ORDER DETAILS'
      ];
      allLinesSummary().filter((row) => row.quantity > 0).forEach((row) => {
        body.push('', `${row.line.brand} - ${row.line.name} | Total pairs: ${row.quantity} | Pair price: ${money(row.price)} | Line total: ${money(row.total)}`);
        filledItemsForLine(row.line).forEach((item) => body.push(`- ${item.color} | ${item.power} | ${item.quantity} pairs`));
      });
      body.push('', `Total Pairs: ${totalPairs()}`, `Shipping: ${shippingLabel()}`, `Product Subtotal: ${money(productSubtotal())}`, `Grand Total: ${money(productSubtotal() + shippingValue())}`);
      return body.join('\n');
    }

    function buildOrderPayload() {
      const company = companyData();
      const lines = [];
      const items = [];
      allLinesSummary().filter((row) => row.quantity > 0).forEach((row) => {
        lines.push({
          brand: row.line.brand, productLine: row.line.name, product_line: row.line.name,
          totalPairs: row.quantity, total_pairs: row.quantity, pairPrice: row.price,
          pair_price: row.price, lineTotal: row.total, line_total: row.total
        });
        filledItemsForLine(row.line).forEach((item) => items.push({
          brand: row.line.brand, productLine: row.line.name, product_line: row.line.name,
          color: item.color, colorDisplay: item.color, color_display: item.color, power: item.power,
          qtyPairs: item.quantity, qty_pairs: item.quantity, pairPrice: row.price,
          pair_price: row.price, lineTotal: item.quantity * row.price, line_total: item.quantity * row.price
        }));
      });
      return {
        source: 'Shopify',
        company: {
          companyName: company.company_name || '', company_name: company.company_name || '',
          contactName: company.contact_name || '', contact_name: company.contact_name || '',
          email: company.email || '', contactNumber: company.contact_number || '',
          contact_number: company.contact_number || '', country: company.country || ''
        },
        lines,
        items,
        summary: {
          totalPairs: totalPairs(), total_pairs: totalPairs(), shippingLabel: shippingLabel(),
          shipping: shippingLabel(), productSubtotal: productSubtotal(), product_subtotal: productSubtotal(),
          grandTotal: productSubtotal() + shippingValue(), grand_total: productSubtotal() + shippingValue()
        },
        message: buildEmailBody()
      };
    }

    function renderAll() {
      renderBrandList();
      renderLineList();
      renderGrid();
      renderLiveSummary();
    }

    companyForm.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!companyForm.checkValidity()) {
        companyForm.reportValidity();
        return;
      }
      submittedOrderHash = null;
      setStep('builder');
      renderAll();
    });

    brandList.addEventListener('click', (event) => {
      const button = event.target.closest('[data-brand]');
      if (!button || (button.dataset.brand !== state.activeBrand && !canLeaveActiveLine())) return;
      state.activeBrand = button.dataset.brand;
      state.activeLineId = linesByBrand(state.activeBrand)[0].id;
      renderAll();
    });

    lineList.addEventListener('click', (event) => {
      const button = event.target.closest('[data-line-id]');
      if (!button || (button.dataset.lineId !== state.activeLineId && !canLeaveActiveLine())) return;
      state.activeLineId = button.dataset.lineId;
      state.activeBrand = getLine(state.activeLineId).brand;
      renderAll();
    });

    gridWrap.addEventListener('input', (event) => {
      const input = event.target.closest('[data-grid-input]');
      if (!input) return;
      input.value = input.value.replace(/[^0-9]/g, '');
      setQty(input.dataset.lineId, input.dataset.color, input.dataset.power, input.value);
      renderLineList();
      renderLiveSummary();
    });

    root.querySelector('[data-b2b-back-company]').addEventListener('click', () => setStep('company'));
    root.querySelector('[data-b2b-edit-order]').addEventListener('click', () => setStep('builder'));
    root.querySelector('[data-b2b-review-order]').addEventListener('click', () => {
      if (!validateOrder()) return;
      renderFinalSummary();
      setStep('summary');
    });
    modal.addEventListener('click', (event) => {
      if (event.target.closest('[data-b2b-modal-close]')) closeModal();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !modal.hidden) closeModal();
    });

    finalSummary.addEventListener('click', (event) => {
      const button = event.target.closest('[data-b2b-submit]');
      if (!button || !validateOrder()) return;
      if (!endpoint) {
        showModal({ title: labels.notConfiguredTitle, message: labels.endpointMissing });
        return;
      }
      button.disabled = true;
      button.textContent = labels.sending;
      fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(buildOrderPayload())
      }).then(() => {
        submittedOrderHash = orderHash();
        showModal({ title: labels.submittedTitle, message: labels.successMessage, button: labels.close });
        button.textContent = labels.requestSent;
      }).catch(() => {
        showModal({ title: labels.errorTitle, message: labels.errorMessage });
        button.textContent = labels.submitRequest;
        button.disabled = false;
      });
    });

    renderAll();
  }

  function initializeAll(scope = document) {
    scope.querySelectorAll('[data-pl-b2b-root]').forEach(initialize);
  }

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
